import '.ig{display:inline-block;}.ssr-plugin'
import '.ih{margin-top:1.5rem;}.ssr-plugin'
import '.bf{font-size:0.875rem;}.ssr-plugin'
import '.ii{color:var(--palette-blue-500);}.ssr-plugin'
import '.h2{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="ig ih bf ii h2"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
